import script from "./ConsultationNumberBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationNumberBadge.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__